import { TestId } from "#/test-ids";

window.Sparkle ??= {};
window.Sparkle.LocationBrowser ??= {};
window.Sparkle.LocationBrowser.Views ??= {};

Sparkle.LocationBrowser.Views.Navigation = class Navigation extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.updateTransitionDirection = this.updateTransitionDirection.bind(this);
    this.update = this.update.bind(this);
    this.render = this.render.bind(this);
    this.buildWrapper = this.buildWrapper.bind(this);
    this.buildContentHtml = this.buildContentHtml.bind(this);
    this.mountSearchForm = this.mountSearchForm.bind(this);
    this.animateWrapper = this.animateWrapper.bind(this);
    this.animateListContent = this.animateListContent.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.renderNavList = this.renderNavList.bind(this);
    this.renderNavItem = this.renderNavItem.bind(this);
    this.renderLocationDetails = this.renderLocationDetails.bind(this);
    this.renderAddress = this.renderAddress.bind(this);
    this.renderDirectionsLink = this.renderDirectionsLink.bind(this);
    this.parseAddressProps = this.parseAddressProps.bind(this);
    this.remove = this.remove.bind(this);
  }

  initialize(options = {}) {
    this.props = options;
    this.searchText = options.searchText || "";
    return (this.searchFormView = null);
  }

  updateTransitionDirection(newProps) {
    const root = this.props.root || {};
    const newRoot = newProps.root || {};

    /*
      If both root nodes are empty, then a search was performed
      so the transition defaults to down. The animation
      will only apply to lb-nav-list.

      If the root node we are going to is empty, that means
      we are going to the top most node, so we are going up.
      (currentParent is set to null on the locations collection
      for the initial node).

      otherwise if the old node is a descendant of the new node,
      we are also going up.

      In all other cases, we are going down. It is possible that
      this logic will cause incorrect animations in edge cases,
      like a user directly manipulating the URL in a very specific
      sequence.
    */

    if (_.isEmpty(newRoot) && _.isEmpty(root)) {
      this.transitionName = "lb-down";
    } else if (_.isEmpty(newRoot) || _.contains(newRoot.child_ids, root.id)) {
      this.transitionName = "lb-up";
    } else {
      this.transitionName = "lb-down";
    }

    return (this.searchText = newProps.searchText || "");
  }

  update(props) {
    this.updateTransitionDirection(props);
    const oldKey = this.props.root ? "branch" : "root";
    const newKey = props.root ? "branch" : "root";
    this.props = props;
    if (oldKey !== newKey) {
      return this.animateWrapper();
    } else {
      return this.animateListContent();
    }
  }

  render() {
    if (this.searchFormView != null) {
      this.searchFormView.remove();
    }
    this.$el.html(this.buildWrapper());
    this.mountSearchForm();
    return this;
  }

  buildWrapper() {
    const { root } = this.props;
    const locations = this.props.locations || [];

    let navWrapperClasses = "lb-nav-wrapper";
    if (this.props.searchActive && !root) {
      navWrapperClasses += " search-active";
    }

    const headerHtml = this.renderHeader(root);
    const contentHtml = this.buildContentHtml(locations, root);
    const key = root ? "branch" : "root";

    return `\
<div class="${navWrapperClasses}" data-key="${key}">
  ${headerHtml}
  <div class="lb-search-container"></div>
  <div class="lb-nav-list-content">
    <div class="lb-nav-list-wrapper">
      ${contentHtml}
    </div>
  </div>
</div>\
`;
  }

  buildContentHtml(locations, root) {
    if (locations.length > 0) {
      return this.renderNavList(locations);
    } else if (root) {
      return this.renderLocationDetails(root);
    } else {
      return "";
    }
  }

  mountSearchForm() {
    if (this.searchFormView != null) {
      this.searchFormView.remove();
    }
    this.searchFormView = new Sparkle.LocationBrowser.Views.SearchForm({
      searchText: this.searchText,
      searchActive: this.props.searchActive,
      lat: this.props.lat,
      lng: this.props.lng,
      name: this.props.name,
      distance: this.props.distance,
      hidden: !!this.props.root,
    });

    return this.$el.find(".lb-search-container").replaceWith(this.searchFormView.render().el);
  }

  // Animate the entire nav wrapper (root <-> branch transitions)
  animateWrapper() {
    const direction = this.transitionName;
    const oldWrapper = this.$el.children(".lb-nav-wrapper");
    const oldSearchFormView = this.searchFormView;

    // Build new content
    const newHtml = this.buildWrapper();
    const newWrapper = jQuery(newHtml);

    // Mount search form into the new wrapper
    this.searchFormView = new Sparkle.LocationBrowser.Views.SearchForm({
      searchText: this.searchText,
      searchActive: this.props.searchActive,
      lat: this.props.lat,
      lng: this.props.lng,
      name: this.props.name,
      distance: this.props.distance,
      hidden: !!this.props.root,
    });

    newWrapper.find(".lb-search-container").replaceWith(this.searchFormView.render().el);

    // Add leave classes to old, enter classes to new
    oldWrapper.addClass(`${direction}-leave`);
    newWrapper.addClass(`${direction}-enter`);

    this.$el.append(newWrapper);

    // Force reflow then activate transitions
    newWrapper[0].offsetHeight;
    oldWrapper.addClass(`${direction}-leave-active`);
    newWrapper.addClass(`${direction}-enter-active`);

    // Clean up after transition — remove old wrapper and its search form
    oldWrapper.one("transitionend", () => {
      if (oldSearchFormView != null) {
        oldSearchFormView.remove();
      }
      return oldWrapper.remove();
    });
    return newWrapper.one("transitionend", () =>
      newWrapper.removeClass(`${direction}-enter ${direction}-enter-active`),
    );
  }

  // Animate just the list content (same-level navigation)
  animateListContent() {
    const direction = this.transitionName;
    const listContainer = this.$el.find(".lb-nav-list-content");
    const oldListWrapper = listContainer.children(".lb-nav-list-wrapper");

    // Update header and search form without animation
    this.$el.find(".lb-header").replaceWith(this.renderHeader(this.props.root));
    if (this.searchFormView != null) {
      this.searchFormView.update({
        searchText: this.searchText,
        searchActive: this.props.searchActive,
        lat: this.props.lat,
        lng: this.props.lng,
        name: this.props.name,
        distance: this.props.distance,
        hidden: !!this.props.root,
      });
    }

    // Build new list content
    const locations = this.props.locations || [];
    const contentHtml = this.buildContentHtml(locations, this.props.root);
    const newListWrapper = jQuery(`<div class='lb-nav-list-wrapper'>${contentHtml}</div>`);

    // Add leave/enter classes
    oldListWrapper.addClass(`${direction}-leave`);
    newListWrapper.addClass(`${direction}-enter`);

    listContainer.append(newListWrapper);

    // Force reflow then activate transitions
    newListWrapper[0].offsetHeight;
    oldListWrapper.addClass(`${direction}-leave-active`);
    newListWrapper.addClass(`${direction}-enter-active`);

    // Clean up after transition
    oldListWrapper.one("transitionend", () => oldListWrapper.remove());
    newListWrapper.one("transitionend", () =>
      newListWrapper.removeClass(`${direction}-enter ${direction}-enter-active`),
    );

    return this;
  }

  handleNavBack(e) {
    const parentId = jQuery(e.currentTarget).data("parent-id");
    return Sparkle.LocationBrowser.instance.changeParentParams({ id: parentId });
  }

  handleNavClick(e) {
    e.preventDefault();
    const url = jQuery(e.currentTarget).data("url");
    if (url) {
      return Sparkle.LocationBrowser.instance.changeParentParams({ url });
    }
  }

  handleDetailsClick(e) {
    const location = this.props.root;
    if (location) {
      const absoluteUrl = jQuery("<a>", { href: location.url }).prop("href");
      return jQuery(document).trigger("search-select.sparkle", [
        "location-browser",
        null,
        absoluteUrl,
        "Location",
        location.id,
      ]);
    }
  }

  renderHeader(root) {
    const headerText = (root != null ? root.name : undefined) || Sparkle.LocationBrowser.t("all_locations");
    const backButton = (root != null ? root.name : undefined)
      ? `<i class='icon-arrow-back back-arrow' data-testid='${TestId.locationBrowser.back}' data-parent-id='${root.parent_id}'></i>`
      : "";

    return `<header class="lb-header" data-testid="${TestId.locationBrowser.header}">${backButton}<span class="lb-header-text">${_.escape(headerText)}</span></header>`;
  }

  renderNavList(locations) {
    const total = locations.length;
    const items = Array.from(locations).map((location, index) => this.renderNavItem(location, index, total));

    return `<ul class='lb-nav-list' data-testid='${TestId.locationBrowser.list}'>${items.join("")}</ul>`;
  }

  renderNavItem(location, index, total) {
    let details;
    let image;
    const locationModel = Sparkle.LocationBrowser.instance.locations.get(location.id);
    const children = Sparkle.LocationBrowser.instance.locations.scoped(locationModel.children());
    const letter = String.fromCharCode(97 + index).toUpperCase();

    if (children.length > 0) {
      image = `<img src='${window.Sparkle.apiHost + this.groupLabelPaths[index]}' alt=''/>`;
      details = `<div class='adr'><p>${children.length} Locations</p></div>`;
    } else {
      const address = _.findWhere(location.addresses, { primary: true });
      if (address) {
        const addressProps = this.parseAddressProps(address);
        image = `<img src='${window.Sparkle.apiHost + this.labelPaths[index]}' alt=''/>`;
        details = this.renderAddress(addressProps);
      }
    }

    let figureImage = "";
    if (total <= 26) {
      figureImage = `\
<figure class="lb-terminal-thumbnail">
  ${image || ""}
</figure>\
`;
    }

    if (location.parent_id) {
      return `\
<li class="lb-terminal-item">
  <a role="button" tabIndex="0" data-testid="${TestId.locationBrowser.item}" data-url="${_.escape(location.url)}">
    ${figureImage}
    <div class="lb-terminal-details">
      <span class="lb-terminal-title">${_.escape(location.name)}</span>
      ${details || ""}
    </div>
    <i class="icon-chevron-right"></i>
  </a>
</li>\
`;
    } else {
      return `\
<li>
  <a role="button" tabIndex="0" data-testid="${TestId.locationBrowser.item}" data-url="${_.escape(location.url)}">
    <span class="lb-terminal-title">${_.escape(location.name)}</span>
    <i class="icon-chevron-right"></i>
  </a>
</li>\
`;
    }
  }

  renderLocationDetails(root) {
    const address = _.findWhere(root.addresses, { primary: true });
    if (!address) {
      return "<section></section>";
    }

    const addressProps = this.parseAddressProps(address);

    let phoneNumbers = "";
    for (var phone of Array.from(address.phone_number_assignments || [])) {
      phoneNumbers += `\
<section class="lb-details-phone">
  <header class="lb-details-header">${_.escape(phone.category)}</header>
  <p>${phone.number}</p>
</section>\
`;
    }

    let locationImage = "";
    if (root.thumbnail) {
      const imageUrl = root.thumbnail.replace("ptn_", "");
      locationImage = `<figure style='background-image: url(${imageUrl})'></figure>`;
    }

    let extraInfo = "";
    if (root.show_more_link) {
      extraInfo = `<a class="location-link" href="${root.public_path}">${Sparkle.LocationBrowser.t("see_more_details")}</a>`;
    } else {
      for (var hour of Array.from(address.hours || [])) {
        extraInfo += `\
<section class="lb-details-hours">
  <h5>${_.escape(hour.label)}</h5>
  <p>${hour.times}</p>
</section>\
`;
      }
    }

    return `\
<section class="lb-details" data-testid="${TestId.locationBrowser.details}">
  ${locationImage}
  <div class="lb-details-inner">
    <section class="lb-details-address">
      <header class="lb-details-header">${Sparkle.LocationBrowser.t("address")}</header>
      ${this.renderAddress(addressProps)}
      ${this.renderDirectionsLink(root.name, addressProps)}
    </section>
    ${phoneNumbers}
    ${extraInfo}
  </div>
</section>\
`;
  }

  renderAddress(props) {
    let extendedAddressText = _.compact([props.regionAbbr, props.postalCode]).join(" ");
    extendedAddressText = _.compact([props.locality, extendedAddressText]).join(", ");
    return `\
<div class="adr">
  <p><span class="street-address">${_.escape(props.streetFirstLine || "")}</span></p>
  <p>${_.escape(props.streetSecondLine || "")}</p>
  <p><span class="extended-address-text">${_.escape(extendedAddressText)}</span></p>
</div>\
`;
  }

  renderDirectionsLink(name, props) {
    if (!(props.query != null ? props.query.length : undefined)) {
      return "<div class='lb-no-directions'></div>";
    }
    const href = `https://www.google.com/maps/dir/?api=1&destination=${props.query}`;
    return `\
<div class="lb-directions">
  <a href="${href}">
    <i class="icon-directions-outlined"></i>
    ${Sparkle.LocationBrowser.t("directions_link")}
  </a>
</div>\
`;
  }

  parseAddressProps(address) {
    return {
      name: address.locale_name,
      streetFirstLine: address.first_line,
      streetSecondLine: address.second_line,
      locality: address.city,
      region: address.full_state_name,
      regionAbbr: address.state,
      postalCode: address.zip_code,
      query: address.to_query,
    };
  }

  remove() {
    if (this.searchFormView != null) {
      this.searchFormView.remove();
    }
    return super.remove(...arguments);
  }
};
Sparkle.LocationBrowser.Views.Navigation.prototype.className = "lb-nav-content";
Sparkle.LocationBrowser.Views.Navigation.prototype.transitionName = "lb-down";
Sparkle.LocationBrowser.Views.Navigation.prototype.searchText = "";
Sparkle.LocationBrowser.Views.Navigation.prototype.groupLabelPaths = window.SparkleConfig.assetPaths.mapLabelGroups;
Sparkle.LocationBrowser.Views.Navigation.prototype.labelPaths = window.SparkleConfig.assetPaths.mapLabels;

Sparkle.LocationBrowser.Views.Navigation.prototype.events = {
  "click .back-arrow": "handleNavBack",
  "click a[data-url]": "handleNavClick",
  "click .location-link": "handleDetailsClick",
};
